const makeInitialState = data => ({
  id: data ? data.id : '',
  implicitRate: data ? data.implicitRate : '',
  name: data ? data.name : '',
  insurance: data ? data.insurance : null
});

export default makeInitialState;
